module.exports = __webpack_public_path__ + "img/img-main-bg02M.8b9a8733.png";